if (!customElements.get('tarim-editorial')) {
  customElements.define('tarim-editorial', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.wide = matchMedia('(min-width:990px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.querySelectorAll('.te-chapter > .te-visual').forEach(panel => {
        panel.removeAttribute('data-editorial-hold');
        if (panel.matches('figure') || panel.querySelector(':scope > .te-heading')) return;
        const figure = Array.from(panel.children).find(child => child.matches('figure'));
        if (!figure || !figure.previousSibling) return;
        const heading = document.createElement('div');
        heading.className = 'te-heading';
        while (panel.firstChild && panel.firstChild !== figure) heading.append(panel.firstChild);
        panel.prepend(heading);
      });
      this.measure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const header = document.querySelector('#header-component');
          const offset = Math.ceil(header?.getBoundingClientRect().height || 70) + 24;
          this.style.setProperty('--te-top', offset + 'px');
          this.querySelectorAll('.te-chapter').forEach(chapter => {
            const panel = Array.from(chapter.children).find(child => child.matches('.te-visual'));
            const figure = panel?.matches('figure') ? panel : panel?.querySelector(':scope > figure');
            if (!figure) return;
            const copy = Array.from(chapter.children).find(child => child !== panel);
            const imageHeight = figure.getBoundingClientRect().height;
            const captionHeight = figure.querySelector('figcaption')?.getBoundingClientRect().height || 0;
            const hold = this.wide.matches && !this.reduced.matches &&
              imageHeight + captionHeight + offset + 36 <= innerHeight &&
              (copy?.getBoundingClientRect().height || 0) > imageHeight + 32;
            figure.toggleAttribute('data-editorial-hold', hold);
          });
        });
      };
      this.observer = new ResizeObserver(this.measure);
      this.querySelectorAll('.te-chapter, .te-chapter img').forEach(node => this.observer.observe(node));
      this.wide.addEventListener('change', this.measure, {signal:this.controller.signal});
      this.reduced.addEventListener('change', this.measure, {signal:this.controller.signal});
      window.addEventListener('resize', this.measure, {passive:true,signal:this.controller.signal});
      this.addEventListener('load', this.measure, {capture:true,signal:this.controller.signal});
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.measure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}